"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWindowSize = useWindowSize;
var _react = require("react");
function useWindowSize() {
  const [windowSize, setWindowSize] = (0, _react.useState)({
    width: 0,
    height: 0
  });
  (0, _react.useEffect)(() => {
    const handler = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    // Set size at the first client-side load
    handler();
    window.addEventListener('resize', handler);

    // Remove event listener on cleanup
    return () => {
      window.removeEventListener('resize', handler);
    };
  }, []);
  return windowSize;
}